import { render, staticRenderFns } from "./EditBanks.vue?vue&type=template&id=946675b2&scoped=true"
import script from "./EditBanks.vue?vue&type=script&lang=js"
export * from "./EditBanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946675b2",
  null
  
)

export default component.exports